export default __webpack_public_path__ + "media/fonts/foundation-icons/svgs/fi-social-picasa-3db19cc89de6baa3089eabf39f3b5257.svg";